import { z } from "zod";
const number = z.number().finite();
const nullableNumber = number.nullable();
export const PortfolioContractTypeSchema = z.enum(["cleared", "otc_financial", "physical", "unclassified"]);
export const PortfolioMeasureSchema = z.object({
    hours: nullableNumber,
    mwh: nullableNumber,
    // MWh divided by this product shape's calendar-month hours in the chosen scope.
    averageMW: nullableNumber,
    entryNotionalEUR: nullableNumber,
    marketNotionalEUR: nullableNumber,
});
export const PortfolioRowSchema = z.object({
    id: z.string(),
    sourceId: z.string().nullable(),
    sourceKind: z.enum(["trade", "deal"]),
    commodity: z.enum(["power", "gas", "unknown"]),
    contractType: PortfolioContractTypeSchema,
    product: z.string(),
    period: z.string(),
    exposureMonth: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
    instrumentPeriod: z.string(),
    instrumentDeliveryStart: z.string(),
    instrumentDeliveryEnd: z.string(),
    deliveryStart: z.string(),
    deliveryEnd: z.string(),
    book: z.string().nullable(),
    trader: z.string().nullable(),
    side: z.enum(["B", "S"]).nullable(),
    quantityMW: nullableNumber,
    entryPrice: nullableNumber,
    currency: z.string(),
    priceUnit: z.string(),
    marketPrice: nullableNumber,
    marketCurrency: z.string(),
    marketPriceUnit: z.string(),
    markDate: z.string().nullable(),
    // Optional for compatibility with existing snapshots. Identifies the actual
    // exchange delivery period used to price this monthly exposure contribution.
    marketReference: z.object({ period: z.string(), deliveryStart: z.string(), deliveryEnd: z.string() }).nullable().optional(),
    fxDate: z.string().nullable(),
    fxRate: nullableNumber,
    fxSource: z.string().nullable(),
    full: PortfolioMeasureSchema,
    remaining: PortfolioMeasureSchema,
    issues: z.array(z.string()),
});
export const PortfolioResponseSchema = z.object({
    asOf: z.string(),
    evaluatedAt: z.string(),
    bankStatementDate: z.string().nullable(),
    latestTradeDate: z.string().nullable(),
    settlementStatus: z.string(),
    rows: z.array(PortfolioRowSchema),
    exclusions: z.array(z.object({ product: z.string(), period: z.string(), reason: z.string() })),
});
//# sourceMappingURL=eex-portfolio-contracts.js.map